import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../../../../components/Rodal/Rodal';
import './MobileAppLinkModal.scss';
import AppStoreQr from '../../../../assets/mobile-app/app-store-qr-code.svg';
import GooglePlayQr from '../../../../assets/mobile-app/google-play-qr-code.svg';
import Helpers from '../../../../utils/helper';

export const MobileAppLinkModal = ({
    type,
    close,
}: {
    type: 'AppStore' | 'GooglePlay';
    close: () => void;
}) => {
    return (
        <div className="mobile-app-link-modal">
            <Rodal
                visible={true}
                onClose={() => close()}
                closeMaskOnClick={true}
                width={450}>
                <ModalHeader>
                    {type == 'AppStore' ? 'App Store' : 'Google Play'} Download
                </ModalHeader>
                <ModalBody>
                    <img
                        onClick={() =>
                            Helpers.openWebsite(
                                type === 'AppStore'
                                    ? 'https://apps.apple.com/app/vetvalue-ecosystem/id1671646043'
                                    : 'https://play.google.com/store/apps/details?id=pet.vetvalue.vvecosystem'
                            )
                        }
                        src={
                            type === 'AppStore' ? AppStoreQr : GooglePlayQr
                        }></img>
                    <p>Scan the QR code with your mobile device</p>
                </ModalBody>
            </Rodal>
        </div>
    );
};
